var cannotLoadAjax = "Can not process your request";
var innovaApiUrl = "https://dev.innova.com/api";//$("#InnovaApiUrl").val();
var innovaApiKey = "H/Fp0tLdQVwq/DwPWwBcH7Rzacrf+59K2Ko9cmxxe648ygmh9TT7vJrmyyVf9vRh";//$("#InnovaKey").val();

$(document).ready(function ($) {
  $("#Phone").inputmask("999-999-9999");
  var captchaKey = $("#GoogleCaptchaKey").val();
  $("div.g-recaptcha").attr("data-sitekey", captchaKey);  
});

function setCurrentStep(step){
  switch (step)
  {
    case 1:
      resetCaptchar(0);
      $("#step1").show();
      $("#step2").hide();
      $("#step3").hide();
      break;
    case 2:
      resetCaptchar(1);
      $("#step1").hide();
      $("#step2").show();
      $("#step3").hide();
      break;
    case 3:
      resetCaptchar(2);
      $("#step1").hide();
      $("#step2").hide();
      $("#step3").show();
      break;
  }
}

function validateEmailNotSellInfo()
{  
  $("#errorMessage").hide();
  var isValid = validateUserRequestForm('step1');
  
  if(isValid){ 
	 $('#ModalContentAjax').modal("show");
     var email = $("div#step1 input[id=EmailAddress]").val();
        xhr = $.ajax({
            type: "POST",
            crossOrigin: true,
            url: innovaApiUrl + "/supports/check-existed-email",
            data: "Email="+ email,
            beforeSend: function (xhr) {
              xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
            },
            error: function () {
              $('#ModalContentAjax').modal("hide");
              resetCaptcharAll();
              alert(cannotLoadAjax);
            },
            success: function (result) {
                $('#ModalContentAjax').modal("hide");
                if(result.message.success){                 
                  if(result.existedUser ){
                    $("#UserEmail").val(email);
					setCurrentStep(2);
                  }else{
                     $("#Email").val(email);
                  	setCurrentStep(3);
                  }
                }else{
                	$("#errorMessage").html(result.message.description);
    				$("#errorMessage").show();
                }
              	resetCaptcharAll();
            }
        });   
  }
  
  return false;
}

function oldUserRequestNotSellInfo(){
  $("#errorMessage").hide();
  var isValid = validateUserRequestForm('step2');
  
  if(isValid){ 
	 $('#ModalContentAjax').modal("show");
     var requestType = $("#RequestType").val();
     var email = $("div#step2 input[id=UserEmail]").val();
     var psw = $("div#step2 input[id=Password]").val();
        xhr = $.ajax({
            type: "POST",
            crossOrigin: true,
            url: innovaApiUrl + "/supports/old-user-request-info",
            data: "Email="+ email + "&Password=" + psw + "&RequestType=" + requestType,//$("#step2").serialize(),
            beforeSend: function (xhr) {
              xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
            },
            error: function () {
              $('#ModalContentAjax').modal("hide");
              resetCaptcharAll();
              alert(cannotLoadAjax);
            },
            success: function (result) {
                $('#ModalContentAjax').modal("hide");
                if(result.message.success){                 
                  if(result.existedUser ){                   
                    window.location = "/pages/consumermessage";                    
                  }else{
                    $("#errorMessage").html(result.message.description);
                    $("#errorMessage").show();
                  }
                }else{
                	$("#errorMessage").html(result.message.description);
    				$("#errorMessage").show();
                }
              	resetCaptcharAll();
            }
        });   
  }
  
  return false;
}

function newUserRequestNotSellInfo(){
  $("#errorMessage").hide();
  var isValid = validateUserRequestForm('step3');
  
  if(isValid){ 
	 $('#ModalContentAjax').modal("show");     
        xhr = $.ajax({
            type: "POST",
            crossOrigin: true,
            url: innovaApiUrl + "/supports/new-user-request-info",
            data: $("#frmPersonalInfo").serialize(),
            beforeSend: function (xhr) {
              xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
            },
            error: function () {
              $('#ModalContentAjax').modal("hide");
              resetCaptcharAll();
              alert(cannotLoadAjax);
            },
            success: function (result) {
                $('#ModalContentAjax').modal("hide");
                if(result.message.success && result.existedUser){
                    window.location = "/pages/consumermessage"; 
                }else{
                	$("#errorMessage").html(result.message.description);
    				$("#errorMessage").show();
                }
              	resetCaptcharAll();
            }
        });   
  }
  
  return false;
}

function validateUserRequestForm(contentId){
  var isValid = checkRequiredFields(contentId);
  var capcharVal = $("#captchaText").val();
  var errorMsg = "";
  $("#errorMessage").hide();
  
  if(!isValid){
  	errorMsg = "The field highlighted in red is required and must be filled out.";
  }
  if(capcharVal != 1 ){
    if(errorMsg != "")
      errorMsg += "<br/>";
    
    errorMsg += "Invalid security code.";
  }
  if(!IsEmailFields(contentId)){
  	if(errorMsg != "")
      errorMsg += "<br/>";
    
    errorMsg += "Email format is invalid.";
  }
  
  if(contentId == "step3"){
    if(!IsPhoneNumber(contentId)){
      if(errorMsg != "")
        errorMsg += "<br/>";

      errorMsg += "Phone Number is invalid.";
    }
  }
  
  if(errorMsg != ""){
  	$("#errorMessage").html(errorMsg);
    $("#errorMessage").show();
  }
  
  return (errorMsg == "");
}

var actCallback = function (response) {
  	
      $("#captchaText").val("1");
      $('#re-captcha').remove();
    
  };
  var expCallback = function() {
    $("#captchaText").val("0");
    resetCaptcharAll();
     setTimeout(function(){
       resetCaptcharAll();
     }, 30000);
  };

  var onloadCallback = function() {
    var captchaKey = $("#GoogleCaptchaKey").val();
    var recaptchas = document.querySelectorAll('div[class=g-recaptcha]');

    for( i = 0; i < recaptchas.length; i++) {
      grecaptcha.render(document.getElementById('re-captchaStep' + i), {
        'sitekey' : captchaKey,
        'callback' : actCallback,
        'expired-callback': expCallback,
      });
    }
  }

  function resetCaptchar(index){
  	 $("#captchaText").val("0");
     $('#re-captcha' + index).show();             
	 grecaptcha.reset(index);
  }

  function resetCaptcharAll(){
 	var recaptchas = document.querySelectorAll('div[class=g-recaptcha]');
    for( i = 0; i < recaptchas.length; i++) {
      grecaptcha.reset(i);
    }
  }

/*

function submitDoNotSellMyInfo ()
{
  $("#errorMessage").hide();
  if(validateNotSellInfoForm()){ 
	 $('#ModalContentAjax').modal("show");
        xhr = $.ajax({
            type: "POST",
            crossOrigin: true,
            url: innovaApiUrl + "/supports/do-not-sell-my-info",
            data: $("#frmPersonalInfo").serialize(),
            beforeSend: function (xhr) {
              xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
            },
            error: function () {
              $('#ModalContentAjax').modal("hide");
              alert(cannotLoadAjax);
            },
            success: function (result) {
                $('#ModalContentAjax').modal("hide");
                if(result.message.success){
					window.location = "/pages/support-message";
                }else{
                	$("#errorMessage").html(result.message.description);
    				$("#errorMessage").show();
                }
            }
        });   
  }
  
  return false;
}

function validateNotSellInfoForm(){
  var isValid = checkRequired();
  var capcharVal = $("#captchaText").val();
  var errorMsg = "";
  $("#errorMessage").hide();
  
  if(!isValid){
  	errorMsg = "The field highlighted in red is required and must be filled out.";
  }
  
   if(!IsEmail()){
  	if(errorMsg != "")
      errorMsg += "<br/>";
    
    errorMsg += "Email format is invalid.";
  }
  
  if(capcharVal != 1 ){
    if(errorMsg != "")
      errorMsg += "<br/>";
    
    errorMsg += "Invalid security code.";
  }
  
  if(errorMsg != ""){
  	$("#errorMessage").html(errorMsg);
    $("#errorMessage").show();
  }
  
  return (errorMsg == "");
}

var actCallback = function (response) {
  	
      $("#captchaText").val("1");
      $('#re-captcha').remove();
    
  };
  var expCallback = function() {
     $("#captchaText").val("0");
  };
 
  var onloadCallback = function () {
    var captchaKey = $("#GoogleCaptchaKey").val();
    var widget = grecaptcha.render(document.getElementById("re-captcha"), {
      'sitekey' : captchaKey, // Sitekey, Retrieving from reCaptcha
      'theme': "light",
      'callback' : actCallback,
      'expired-callback': expCallback,
    });
  }
  
  */